import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core'
import { NbDialogService } from '@nebular/theme'
import { TurnInputDialogComponent, ETurnInputMode } from '../turn-input-dialog/turn-input-dialog.component'
import { ITurnColumn, ITurnInfo, WorkingService } from '../../@core/services/working.service'
import { SharedService } from '../../@core/services/shared.service'
import { PvsResponse } from '../../@core/services/pvs-request.service'
import { differenceInSeconds, parseISO } from 'date-fns'

@Component({
    templateUrl: './turn-column.component.html',
    styleUrls: ['./turn-column.component.scss'],
    selector: 'app-turn-column',
})
export class TurnColumnComponent implements OnInit {
    @Input() data: ITurnColumn
    // tslint:disable-next-line:no-output-on-prefix
    @Output() onDataChange = new EventEmitter<ITurnColumn>()

    constructor(
        public sharedService: SharedService,
        public workingService: WorkingService,
        private dialogService: NbDialogService
    ) {}

    ngOnInit() {
        this.data.turnCnt = this.workingService.calcTurnCnt(this.data.turns)
        this.data.totalAmt = this.workingService.calcTotalAmt(this.data.turns)
        this.data.totalTip = this.workingService.calcTotalTip(this.data.turns)
    }

    onTurnsChanged() {
        this.data.turnCnt = this.workingService.calcTurnCnt(this.data.turns)
        this.data.totalAmt = this.workingService.calcTotalAmt(this.data.turns)
        this.data.totalTip = this.workingService.calcTotalTip(this.data.turns)
        // @ts-ignore
        this.onDataChange.emit(this.data)
    }

    addTurn() {
        const okFunction = (data) => {
            return this.workingService
                .addTurn(this.data.workingDate, this.data.employeeId, data)
                .toPromise(null, () => {
                    this.sharedService.showMessage('Added successfully!')
                })
        }
        this.dialogService
            .open(TurnInputDialogComponent, {
                context: {
                    mode: ETurnInputMode.NEW,
                    employee: this.data.employee,
                    okFunction: okFunction,
                },
            })
            .onClose.subscribe((res: PvsResponse) => {
                if (res) {
                    this.data.turns = this.data.turns.concat([res.data])
                    this.onTurnsChanged()
                }
            })
    }

    updateTurn(turnId) {
        const data = this.data.turns.find((e) => e.id === turnId)
        if (!data) {
            this.sharedService.showErrorMessage('This turn does not exist')
            return
        }
        const okFunction = (editedData) => {
            return this.workingService.updateTurn(turnId, editedData).toPromise(null, () => {
                this.sharedService.showMessage('Saved successfully!')
            })
        }
        const deleteFunction = () => {
            return this.workingService.deleteTurn(turnId).toPromise(null, () => {
                this.sharedService.showMessage('Deleted successfully!')
            })
        }
        this.dialogService
            .open(TurnInputDialogComponent, {
                context: {
                    mode: ETurnInputMode.UPDATE,
                    employee: this.data.employee,
                    data: { ...data, workingDate: this.data.workingDate },
                    okFunction: okFunction,
                    deleteFunction: deleteFunction,
                },
            })
            .onClose.subscribe((res: PvsResponse) => {
                if (res === null) {
                    // delete
                    for (let i = 0; i < this.data.turns.length; i++) {
                        if (this.data.turns[i].id === turnId) {
                            this.data.turns.splice(i, 1)
                            this.onTurnsChanged()
                            break
                        }
                    }
                    return
                }
                if (res) {
                    // update
                    for (let i = 0; i < this.data.turns.length; i++) {
                        if (this.data.turns[i].id === turnId) {
                            this.data.turns[i] = res.data
                            this.onTurnsChanged()
                            break
                        }
                    }
                }
            })
    }
    isBlink(turn: ITurnInfo) {
        // console.log('isBlink checked', turn.id)
        const seconds = differenceInSeconds(new Date(), parseISO(turn.updatedAt))
        return seconds < 6
    }
}
